<app-header-latest></app-header-latest>
<!-- HERO -->
<div class="status-hero">
  <div class="container-wrapper">
    <div class="section-eyebrow" style="color:rgba(255,255,255,0.6);">🟢 SYSTEM STATUS</div>
    <h1>All Systems<br>Operational</h1>
    <p>Real-time status for all NeoHRMZ services and infrastructure.</p>
    <div class="overall-status">
      <div class="overall-status__dot"></div>
      All Systems Operational
    </div>
  </div>
</div>

<!-- METRICS -->
<section class="metrics-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📊 Live Metrics</span>
      <h2 class="sec-h2">Platform<br><span class="gradient-text">Performance</span></h2>
    </div>
    <div class="metrics-grid">
      <div class="metric-card">
        <div class="metric-card__value">99.99%</div>
        <div class="metric-card__label">Uptime (Last 90 Days)</div>
        <div class="metric-card__trend up">↑ 0.01% vs last period</div>
      </div>
      <div class="metric-card">
        <div class="metric-card__value">42ms</div>
        <div class="metric-card__label">Avg. API Response Time</div>
        <div class="metric-card__trend up">↑ Faster than last week</div>
      </div>
      <div class="metric-card">
        <div class="metric-card__value">0</div>
        <div class="metric-card__label">Active Incidents</div>
        <div class="metric-card__trend flat">→ No issues detected</div>
      </div>
      <div class="metric-card">
        <div class="metric-card__value">1.2M</div>
        <div class="metric-card__label">API Requests Today</div>
        <div class="metric-card__trend up">↑ 8% above average</div>
      </div>
    </div>
  </div>
</section>

<!-- COMPONENT STATUS -->
<section class="components-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">⚙️ Component Health</span>
      <h2 class="sec-h2">Service-by-Service<br><span class="gradient-text">Status</span></h2>
    </div>
    <div class="components-list">
      <div class="component-row"><div><div class="component-row__name">Core API (REST v2)</div><div class="component-row__desc">Primary API serving all client requests</div></div><span class="status-pill operational">Operational</span></div>
      <div class="component-row"><div><div class="component-row__name">Payroll Processing Engine</div><div class="component-row__desc">Salary calculation, disbursement, and tax filing</div></div><span class="status-pill operational">Operational</span></div>
      <div class="component-row"><div><div class="component-row__name">Authentication &amp; SSO</div><div class="component-row__desc">SAML, OAuth 2.0, and API key authentication</div></div><span class="status-pill operational">Operational</span></div>
      <div class="component-row"><div><div class="component-row__name">File Storage &amp; Documents</div><div class="component-row__desc">Employee document uploads, payslips, contracts</div></div><span class="status-pill operational">Operational</span></div>
      <div class="component-row"><div><div class="component-row__name">Email &amp; Notification Delivery</div><div class="component-row__desc">Transactional emails, webhook notifications, in-app alerts</div></div><span class="status-pill operational">Operational</span></div>
      <div class="component-row"><div><div class="component-row__name">Attendance &amp; Biometric Sync</div><div class="component-row__desc">Device integrations, clock-in/out processing</div></div><span class="status-pill operational">Operational</span></div>
      <div class="component-row"><div><div class="component-row__name">Analytics &amp; Reporting</div><div class="component-row__desc">Dashboard data, custom reports, data exports</div></div><span class="status-pill operational">Operational</span></div>
      <div class="component-row"><div><div class="component-row__name">AI Assistant</div><div class="component-row__desc">Natural language HR queries and automation</div></div><span class="status-pill operational">Operational</span></div>
    </div>
  </div>
</section>

<!-- UPTIME -->
<section class="uptime-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📈 Uptime History</span>
      <h2 class="sec-h2">90-Day<br><span class="gradient-text">Uptime Record</span></h2>
      <p class="sec-sub">Each bar represents one day. Green = fully operational, yellow = degraded, red = outage.</p>
    </div>
    <div class="uptime-chart">
      <div class="uptime-row">
        <div class="uptime-row__label">Core API</div>
        <div class="uptime-row__bars">
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
        </div>
        <div class="uptime-row__pct">100%</div>
      </div>
      <div class="uptime-row">
        <div class="uptime-row__label">Payroll Engine</div>
        <div class="uptime-row__bars">
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar warn"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
        </div>
        <div class="uptime-row__pct">99.97%</div>
      </div>
      <div class="uptime-row">
        <div class="uptime-row__label">File Storage</div>
        <div class="uptime-row__bars">
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
          <div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div><div class="uptime-bar ok"></div>
        </div>
        <div class="uptime-row__pct">100%</div>
      </div>
    </div>
  </div>
</section>

<!-- INCIDENTS -->
<section class="incidents-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🗓️ Past Incidents</span>
      <h2 class="sec-h2">Incident<br><span class="gradient-text">History</span></h2>
      <p class="sec-sub">Full post-mortems and resolution notes for every incident in the past 90 days.</p>
    </div>
    <div class="incident-list">
      <div class="incident-card">
        <div class="incident-card__header">
          <div class="incident-card__title">Payroll Engine Degraded — Calculation Delays</div>
          <div class="incident-card__date">May 28, 2025 · Resolved</div>
        </div>
        <div class="incident-card__desc">A queue backlog caused payroll calculation delays of 8–12 minutes for approximately 3% of accounts. All pending calculations were processed and the queue was cleared within 47 minutes. Root cause: an unanticipated spike in end-of-month batch requests. Mitigation: dynamic queue scaling deployed.</div>
      </div>
      <div class="incident-card">
        <div class="incident-card__header">
          <div class="incident-card__title">Email Notification Delivery Delays</div>
          <div class="incident-card__date">Apr 14, 2025 · Resolved</div>
        </div>
        <div class="incident-card__desc">Outbound email notifications were delayed by 15–40 minutes due to a third-party SMTP provider issue. All queued emails were delivered once the provider restored normal operation. No data was lost. Provider SLA credit applied.</div>
      </div>
    </div>
  </div>
</section>

<!-- SUBSCRIBE -->
<section class="status-subscribe">
  <div class="container-wrapper">
    <h2 class="status-subscribe__h2">Get Instant Incident Alerts</h2>
    <p class="status-subscribe__p">Subscribe to status updates and receive email or SMS notifications the moment an incident is detected.</p>
    <div class="status-subscribe__form">
      <input type="email" class="status-subscribe__input" placeholder="your@company.com" />
      <a href="#" class="btn btn-white">Subscribe</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>